import request from '@/routes/api/api_conextion';
export function login(alias) {
  return request({
    url: 'autorizacionfront',
    method: 'post',
    data: {
      login: alias
    }
  });
}